import { createContext, useState } from 'react'

import { isFunction } from 'lodash'
import { useSelector } from 'react-redux'

import BadgeRecoveryModal from './BadgeRecoveryModal'
import BadgeAssignationModal from './BadgeAssignationModal'
import { selectUser } from '../../../reducers/UserReducer'
import { getters } from '../../../utils/entities/badge'
import { createBadgeAssignation, updateBadgeAssignation } from '../../../utils/api/badge'
import { isOptimistic } from '../../../utils'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { onError, onInfo, onSuccess } from '../../../utils/apiHelper'

export const Modes = Object.freeze({
  RECOVERY: 1,
  MANAGE: 2
})

export const DEFAULT_CONTEXT = {
  data: null,
  mode: null,
  callback: null
}
export const BadgeAssignationContext = createContext()

const BadgeAssignationProvider = ({ children }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [context, setContext] = useState(DEFAULT_CONTEXT)

  const handleClose = (data, callback) => {
    setContext(DEFAULT_CONTEXT)

    if (isFunction(callback)) {
      callback(data)
    }
  }

  const handleSubmit = data => {
    if (isOptimistic(context.data)) {
      createBadgeAssignation(user, user.institutions[0], data).then(({ data, message }) => {
        if (message) {
          const messageParts = message.split('student')
          onInfo(t(messageParts[0] + 'student') + ' ' + messageParts[1])
        } else {
          handleClose(data, context.callback)
          onSuccess(t('badge_assignation.create.success'))
        }
      }).catch(() => onError(t('badge_assignation.create.error')))
    } else {
      updateBadgeAssignation(user, user.institutions[0], { id: getters.badgeAssignationId(context.data) }, data).then(({ data, message }) => {
        if (message) {
          const messageParts = message.split('student')
          onInfo(t(messageParts[0] + 'student') + ' ' + messageParts[1])
        } else {
          handleClose(data, context.callback)
          onSuccess(t('badge_assignation.update.success'))
        }
      }).catch(() => onError(t('badge_assignation.update.error')))
    }
  }

  return (
    <>
      <BadgeAssignationContext.Provider
        value={{ setContext }}
      >
        {children}
      </BadgeAssignationContext.Provider>
      <BadgeRecoveryModal
        badgeAssignation={context.mode === Modes.RECOVERY ? context.data : null}
        onClose={handleClose}
        onRecover={data => handleClose(data, context.callback)}
      />
      <BadgeAssignationModal
        badgeAssignation={context.mode === Modes.MANAGE ? context.data : null}
        onCancel={() => handleClose()}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default BadgeAssignationProvider
